import { Box, Card, Grid, IconButton, Typography } from "@mui/material";
import { ReactComponent as FailIcon } from '../../assets/icons/condash-failicon.svg';
import { ReactComponent as SuccessIcon } from '../../assets/icons/condash-success.svg';
import { ReactComponent as ListBoxIcon } from '../../assets/icons/ListBoxIcon.svg';
import { ReactComponent as RightArrowIcon } from '../../assets/icons/condash-right-icon.svg';
import { ReactComponent as VerticalLine } from '../../assets/icons/condashvr-line.svg';
import { useMemo, useState } from "react";
import { AssetList } from "./assetsList";
import { Link } from "react-router-dom";
import Snackbar from "../../common/snackBar";



const Styles = {
    cardinnertext: {
        color: '#64759F',
        fontSize: '0.9rem',
        fontWeight: '400',
        fontStyle: 'normal',
        lineHeight: 'normal'
    },
    cardinnernum: {
        color: '#434D67',
        fontSize: '1rem',
        fontWeight: '600',
        fontStyle: 'normal',
        lineHeight: 'normal'
    },
    cardheader: {
        color: '#434D67',
        fontSize: '1.3rem',
        fontWeight: '600',
        fontStyle: 'normal',
        lineHeight: 'normal'
    }
}


export const ConnectivityCard = (props: any) => {

    const connectedDevices = useMemo(() => {
        if (props.data) {
            const data: any = props.data.assets.filter((item: any) => item.connectivity_status === 'connected');
            if (data.length) {
                return data;
            } else {
                return []
            }
        } else {
            return [];
        }

    }, [props]);

    const disConnectedDevices = useMemo(() => {
        if (props.data) {
            const data: any = props.data.assets.filter((item: any) => item.connectivity_status != 'connected');
            if (data.length) {
                return data;
            } else {
                return []
            }
        } else {
            return [];
        }

    }, [props])

    const isNestable = useMemo(() => {
        if (props.ontologyMgmntData) {
            const data = props.ontologyMgmntData.filter((item: any) => item.parent_id === props.data.onto_manage_id);
            if (data.length) {
                return data;
            } else {
                return []
            }
        } else {
            return []
        }
    }, [props])

    const handleLinkClick = ()=>{
        if(!isNestable.length){
            Snackbar.error('Ontology levels not found')
        }
        
    }

    return (
        <Card sx={{padding: '24px', boxShadow: '0px 0px 14px 0px rgba(0, 0, 0, 0.05)' }}>
            <Grid container
                direction="row"

                alignItems="center" sx={{ borderBottom: '1px solid #D9DFED', paddingBottom: '12px', width:'auto' }}>
                <Grid xs={10}>
                    <Typography sx={Styles.cardinnernum}>{props.data.onto_manage_title}</Typography>
                </Grid>
                <Grid xs={2} sx={{ display: 'flex', flexDirection:'row', justifyContent:'flex-end', gap:'10px' }}>
                    {
                        (props?.data?.level_number === props?.levelLength) ?
                            <>
                                <span style={{ marginTop: '0px', height: '22px' }}></span>
                                <IconButton sx={{padding:'0px',':hover':{'color':'none'}}} disabled={(!isNestable.length)} component={Link} to={`/connectivity-dashboard/${(props.data.level_number + 1)}/${props.data.onto_manage_id}`}>

                                </IconButton>
                            </>
                            :
                            <>
                                <span style={{ marginTop: '0px', height: '22px'  }}><VerticalLine /></span>
                                <IconButton sx={{padding:'0px'}} onClick={handleLinkClick} component={Link} to={`/connectivity-dashboard/${(props.data.level_number + 1)}/${props.data.onto_manage_id}`}>
                                    <RightArrowIcon />
                                </IconButton>
                            </>
                    }                   
                </Grid>
            </Grid>
            <Grid container
                direction="row"

                alignItems="center"
                textAlign={'left'} marginTop={'12px'}>
                <Grid xs={2} sx={{display: 'flex', flexDirection:'row', justifyContent:'flex-start'}}> <IconButton sx={{padding:'0px'}}>
                    <SuccessIcon />
                </IconButton></Grid>
                <Grid xs={8}> <Typography sx={Styles.cardinnertext}>Device Connected</Typography></Grid>
                <Grid xs={2} textAlign={'right'} sx={{paddingRight:'5px'}}> <Typography sx={Styles.cardinnernum}>{(connectedDevices.length)}</Typography></Grid>
            </Grid>
            <Grid container
                direction="row"
                alignItems="center" marginTop={'12px'} sx={{borderBottom:'1px solid #D9DFED', paddingBottom:'12px'}}>
                <Grid xs={2} sx={{display: 'flex', flexDirection:'row', justifyContent:'flex-start'}}> <IconButton sx={{padding:'0px'}}>
                    <FailIcon />
                </IconButton></Grid>
                <Grid xs={8}> <Typography sx={Styles.cardinnertext}>Device Disconnected</Typography></Grid>
                <Grid xs={2} textAlign={'right'} sx={{paddingRight:'5px'}}> <Typography sx={Styles.cardinnernum}>{(disConnectedDevices.length)}</Typography></Grid>
            </Grid>
            <Grid container
                direction="row"
                alignItems="center" textAlign={'right'} marginTop={'12px'}>
                <Grid xs={12} sx={{display: 'flex', flexDirection:'row', justifyContent:'flex-end'}}> <IconButton sx={{padding:'0px', ':hover':{background:'transparent'} }} onClick={() => { props.openModal(props.data) }}>
                    <ListBoxIcon style={{color:'#5C85FF'}} />
                    <Typography sx={{fontSize:'1rem', fontWeight:'400', color:'#5C85FF', marginLeft:'4px'}}>View Assets</Typography>
                </IconButton></Grid>
            </Grid>
        </Card>
    )
}